import styled from 'styled-components';

export const GapY = styled.div.withConfig({
  componentId: 'gap-y',
  displayName: 'GapY',
})<{ $gap: string }>`
  height: ${(props) => props.$gap};
`;
